import React from "react"
import Treatment from "../components/tratment/treatment"

import Layout from "../components/layout"
import SEO from "../components/seo"
import image from "../images/face_600x400.jpg"

const description = (
  <div>
    <p>CLEANSING TREATMENT WITH OR WITHOUT EXTRACTION</p>
    <p>
      Balanced Face by FR~HAUT Cosmetics is designed to address skin problems
      that are small everyday obstacles to the work of the beautician: acne,
      dermatitis, scars, dilated pore, ageing…
    </p>
    <p>
      FR~HAUT Cosmetics introduces an excellent therapy that combines the use of
      Alpha and Beta-hydroxy acids. Thanks to this deep peeling of the skin we
      can work with a fundamental tool for a variety of treatments such as
      whiteners or cell regenerators (scars, blemishes or wrinkles). This
      results in a more radiant and younger looking skin.
    </p>
    <p>
      HY+ is the exclusive, rehydrating and anti-ageing treatment with double
      action: on the surface and deep inside the skin to boost the skin’s
      capacity to retain its own water reserves.
    </p>
    <p>
      TelangynTM is the new tetrapeptide developed by Lipotec laboratories that
      combats the undesired effects caused by capillary dilation and tissue
      degradation. Thanks to the dynamics developed by cell activities the depth
      of wrinkles is reduced. The skin absorbs more moisture again and presents
      a homogeneous, vivacious and less reddened appearance. Skin cells receive
      fresh energy. Its success is impressive!
    </p>
    <p>
      White Tea is a global anti-ageing treatment designed to counter and prevent
      the effects the passing of time from showing on our skin. Such effect
      includeS the loss of firmness, elasticity, flaccidity, the appearance of
      wrinkles, expression lines, loss of vitality, brightness, etc. It also
      protects skin from outside aggressions.
    </p>
    <p>
      EVEN brings together a set of patents and natural active substances that
      are the result of biotechnological research. It is a powerful cocktail of
      active substances aimed at depigmenting, protecting and preventing skin’s
      oxidative photoageing. The result: skin will be much whitened, firmer,
      brighter and more radiant
    </p>
    <p>
      Citrus Care combines the microencapsulated vitamin C and beta carotene to
      prevent the photo-ageing of the tissue and give skin a young and radiant
      look. Citrus Care is the ideal treatment before, during and after sun
      exposure but not only.
    </p>
    <p>
      To some of the Freihaut treatments we can add microneedling, needle free
      mesotherapy, microcurrents or ultrasounds for deeper absorbtion of active
      ingridients.
    </p>
  </div>
)

const Facials = () => (
  <Layout>
    <SEO title="Facials" />
    <Treatment image={image} title="Facials" htmlText={description} />
  </Layout>
)

export default Facials
